import {StyleSheet} from 'react-native';
import {connect} from 'react-redux';
import {constant} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import OrderHistoryList from '/component/partial/OrderHistoryList';

const styles = StyleSheet.create({base: {paddingTop: 10}});

export default connect(
  createStructuredSelector({
    style: constant(styles),
  }),
)(OrderHistoryList);
